import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

export const FulfillmentDropdownSkeleton: React.FC = () => {
  const [styles] = useStyles();

  return (
    <View accessibilityState={{ busy: true }} style={styles.container}>
      <AnimatedSkeletonLoader height={14} width={76} />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    borderColor: theme.sk.color.border.input.default,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    minHeight: 42,
    minWidth: 148,
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    paddingVertical: theme.sk.spacing.spaceXsmall,
  },
}));
